import * as React from 'react';

import AccountBilling32 from './AccountBilling32';

export const accountBilling32 = () => <AccountBilling32 />;

export default {
    title: 'Icon/Logo/AccountBilling32',
    component: AccountBilling32,
    parameters: {
        notes: "`import AccountBilling32 from 'box-ui-elements/es/icon/logo/AccountBilling32';`",
    },
};
